import { PropagateLoader } from 'react-spinners';
import { useTheme } from '../providers';

const Loader = () => {
  const { theme } = useTheme();

  const color = theme === 'dark' ? '#868686ff' : '#7e7e7eff';

  return (
    <div className="w-fit py-3">
      <PropagateLoader color={color} size={15} />
    </div>
  );
};

export default Loader;
